<kendo-upload [disabled]="is_disabled" [saveUrl]="save_url" [saveMethod]="'PUT'" [removeUrl]="remove_url" [removeMethod]="'DELETE'" [multiple]="multiple"
              [withCredentials]="false" [restrictions]="restrictions" [(ngModel)]="source_files" (success)="successEventHandler($event)" (remove)="removeEventHandler($event)"
              (select)="selectEventHandler($event)" (complete)="completeEventHandler($event)">
</kendo-upload>
